/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/27/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */

const WEEK = {
  "0": "\u65e5",
  "1": "\u4e00",
  "2": "\u4e8c",
  "3": "\u4e09",
  "4": "\u56db",
  "5": "\u4e94",
  "6": "\u516d"
};

export default function(value, format = "yyyy年MM月dd日 HH:mm:ss") {
  let date;
  if (value instanceof Date) {
    date = value;
  } else {
    try {
      date = new Date(value);
    } catch (e) {
      return "";
    }
  }

  let o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, //小时
    "H+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "t+": date.getMilliseconds() //毫秒
  };

  if (/(D(\d?))/.test(format)) {
    let len = Math.max(+RegExp.$2, 0) || 7;
    let str = "";
    let day = 24 * 60 * 60 * 1000;
    let nDate = date.getTime();
    let now = new Date();

    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    let today = now.getTime();

    now.setDate(1);
    now.setMonth(0);
    let firstDay = now.getTime();

    if (nDate >= today) str = "今天";
    else if (nDate >= today - day && len >= 1) str = "昨天";
    else if (nDate >= today - 2 * day && len >= 2) str = "前天";
    else if (nDate >= today - 3 * day && len >= 3) str = "3天前";
    else if (nDate >= today - 4 * day && len >= 4) str = "4天前";
    else if (nDate >= today - 5 * day && len >= 5) str = "5天前";
    else if (nDate >= today - 6 * day && len >= 6) str = "6天前";
    else if (nDate >= today - 14 * day && len >= 7) str = "1周前";
    else if (nDate >= firstDay) str = "MM月dd日";
    else str = "yyyy年MM月dd日";
    format = format.replace(RegExp.$1, str);
  }

  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  if (/(E+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (RegExp.$1.length > 1
        ? RegExp.$1.length > 2
          ? "\u661f\u671f"
          : "\u5468"
        : "") + WEEK[date.getDay() + ""]
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 && k !== "t+"
          ? o[k]
          : (o[k] + 1000 + "").substr(
              k !== "t+" ? 4 - RegExp.$1.length : 1,
              RegExp.$1.length
            )
      );
    }
  }
  return format;
}
